import React, { FC } from 'react';

import Icon, { NAMES } from '../Icon';

import * as Styled from './styled';

type Props = {
  color: string;
  height?: number;
  text?: string;
  width?: number;
};

/**
 * Attachment icon with file extension
 *
 * @param props        Props passed to the component
 * @param props.color  Color of the icon
 * @param props.height Height of the icon
 * @param props.text   Text to display
 * @param props.width  Width of the icon
 *
 * @returns            The component itself
 */
const FileIcon: FC<Props> = ({ color, height, text, width }) => {
  return (
    <Styled.Wrapper>
      <Icon
        color={color}
        height={height}
        name={NAMES.ATTACHMENT}
        width={width}
      />
      <Styled.Extension data-background-color={color}>{text}</Styled.Extension>
    </Styled.Wrapper>
  );
};

export default FileIcon;
